// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container principal avec marge pour la sidebar */
.clients-container {
  /* margin-left: 230px; */
  padding: 2rem;
  min-height: 100vh;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 100%);
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.clients-title {
  color: #1e293b;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Barre d'outils */
.clients-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  gap: 1rem;
  flex-wrap: wrap;
}

.clients-filters {
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
}

.clients-filters select,
.clients-filters input {
  padding: 0.75rem 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 0.875rem;
  background: white;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  min-width: 140px;
}

.clients-filters input {
  min-width: 200px;
}

.clients-filters select:focus,
.clients-filters input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  transform: translateY(-1px);
}

.clients-filters input::placeholder {
  color: #94a3b8;
}

/* Boutons */
.clients-btn-primary {
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  color: white;
  border: none;
  padding: 0.875rem 1.5rem;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
  white-space: nowrap;
}

.clients-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
}

.clients-btn-primary:active {
  transform: translateY(0);
}

/* Tableau */
.clients-table {
  width: 100%;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  border-collapse: collapse;
}

.clients-table thead {
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
}

.clients-table thead th {
  padding: 1.25rem 1rem;
  text-align: left;
  font-weight: 600;
  color: white;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.clients-table tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: all 0.2s ease;
}

.clients-table tbody tr:hover {
  background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%);
  transform: scale(1.005);
}

.clients-table tbody tr:last-child {
  border-bottom: none;
}

.clients-table tbody td {
  padding: 1rem;
  color: #374151;
  font-size: 0.875rem;
  vertical-align: middle;
}

/* Badge de statut */
.status-badge {
  padding: 0.375rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: inline-block;
  transition: all 0.2s ease;
}

.status-badge.active {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
}

.status-badge.inactive {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
}

/* Boutons d'action */
.clients-btn-edit,
.clients-btn-delete {
  background: none;
  border: none;
  padding: 0.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #6b7280;
  margin: 0 0.25rem;
}

.clients-btn-edit:hover {
  background: #dbeafe;
  color: #3b82f6;
  transform: scale(1.1);
}

.clients-btn-delete:hover {
  background: #fee2e2;
  color: #ef4444;
  transform: scale(1.1);
}

/* Modal */
.clients-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
  animation: clients-modal-fade-in 0.3s ease;
}

@keyframes clients-modal-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.clients-modal-box {
  background: white;
  border-radius: 20px;
  padding: 2rem;
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  animation: clients-modal-slide-up 0.3s ease;
}

@keyframes clients-modal-slide-up {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.clients-modal-title {
  color: #1e293b;
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  text-align: center;
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Formulaire modal */
.clients-modal-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.clients-modal-form input,
.clients-modal-form select {
  padding: 0.875rem;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.2s ease;
  background: white;
}

.clients-modal-form input:focus,
.clients-modal-form select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  transform: translateY(-1px);
}

.clients-modal-form input::placeholder {
  color: #9ca3af;
}

/* Actions de modal */
.modal-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
}

.clients-btn-save {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  padding: 0.875rem 1.5rem;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
  flex: 1 1;
}

.clients-btn-save:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);
}

.clients-btn-cancel {
  background: #f3f4f6;
  color: #374151;
  border: none;
  padding: 0.875rem 1.5rem;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 1 1;
}

.clients-btn-cancel:hover {
  background: #e5e7eb;
  transform: translateY(-1px);
}

/* Responsive */
@media (max-width: 1024px) {
  .clients-container {
    margin-left: 0;
    padding: 1rem;
  }
}

@media (max-width: 768px) {
  .clients-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .clients-filters {
    justify-content: center;
    flex-wrap: wrap;
  }

  .clients-filters select,
  .clients-filters input {
    min-width: auto;
    flex: 1 1;
  }

  .clients-table {
    font-size: 0.75rem;
  }

  .clients-table thead th,
  .clients-table tbody td {
    padding: 0.75rem 0.5rem;
  }

  .clients-modal-box {
    padding: 1.5rem;
    margin: 1rem;
  }

  .modal-actions {
    flex-direction: column;
  }

  .clients-btn-save,
  .clients-btn-cancel {
    flex: none;
  }
}

@media (max-width: 480px) {
  .clients-title {
    font-size: 2rem;
  }

  .clients-table thead th {
    font-size: 0.75rem;
    padding: 1rem 0.5rem;
  }

  .clients-table tbody td {
    font-size: 0.75rem;
    padding: 0.75rem 0.5rem;
  }

  .status-badge {
    font-size: 0.625rem;
    padding: 0.25rem 0.5rem;
  }
}

/* Animations pour les interactions */
.clients-table tbody tr,
.clients-btn-primary,
.clients-btn-save,
.clients-btn-cancel,
.clients-filters input,
.clients-filters select {
  will-change: transform;
}

/* Scrollbar personnalisée pour la modal */
.clients-modal-box::-webkit-scrollbar {
  width: 6px;
}

.clients-modal-box::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.clients-modal-box::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.clients-modal-box::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* États de chargement */
.clients-table tbody tr.loading {
  opacity: 0.6;
  pointer-events: none;
}

/* Focus visible pour l'accessibilité */
.clients-btn-primary:focus-visible,
.clients-btn-save:focus-visible,
.clients-btn-cancel:focus-visible,
.clients-filters input:focus-visible,
.clients-filters select:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

/* Effet de survol sur les lignes du tableau */
.clients-table tbody tr:hover .status-badge.active {
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
}

.clients-table tbody tr:hover .status-badge.inactive {
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
}

/* Animation des boutons d'action */
.clients-btn-edit,
.clients-btn-delete {
  position: relative;
  overflow: hidden;
}

.clients-btn-edit::before,
.clients-btn-delete::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: currentColor;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.3s ease, height 0.3s ease;
  opacity: 0.1;
  z-index: -1;
}

.clients-btn-edit:hover::before,
.clients-btn-delete:hover::before {
  width: 100%;
  height: 100%;
}

/* Amélioration de l'accessibilité */
.clients-btn-edit:focus,
.clients-btn-delete:focus {
  outline: 2px solid currentColor;
  outline-offset: 2px;
}

/* Style pour les messages d'erreur (prêt à utiliser) */
.clients-error-message {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #dc2626;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  border-left: 4px solid #ef4444;
  margin-bottom: 1rem;
  font-size: 0.875rem;
}

/* Style pour les messages de succès (prêt à utiliser) */
.clients-success-message {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  border-left: 4px solid #10b981;
  margin-bottom: 1rem;
  font-size: 0.875rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Clients.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE,wBAAwB;EACxB,aAAa;EACb,iBAAiB;EACjB,6DAA6D;EAC7D,uFAAuF;AACzF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,4DAA4D;EAC5D,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,4CAA4C;AAC9C;;AAEA,qBAAqB;AACrB;;EAEE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;EAC9C,SAAO;AACT;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE;IACE,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,SAAO;EACT;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA,qCAAqC;AACrC;;;;;;EAME,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,uCAAuC;AACvC;;;;;EAKE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,8CAA8C;AAChD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,mCAAmC;AACnC;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,gCAAgC;EAChC,6CAA6C;EAC7C,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA,oCAAoC;AACpC;;EAEE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,uDAAuD;AACvD;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":["/* Container principal avec marge pour la sidebar */\n.clients-container {\n  /* margin-left: 230px; */\n  padding: 2rem;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 100%);\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.clients-title {\n  color: #1e293b;\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 2rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Barre d'outils */\n.clients-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.clients-filters {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.clients-filters select,\n.clients-filters input {\n  padding: 0.75rem 1rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 0.875rem;\n  background: white;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  min-width: 140px;\n}\n\n.clients-filters input {\n  min-width: 200px;\n}\n\n.clients-filters select:focus,\n.clients-filters input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n  transform: translateY(-1px);\n}\n\n.clients-filters input::placeholder {\n  color: #94a3b8;\n}\n\n/* Boutons */\n.clients-btn-primary {\n  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);\n  color: white;\n  border: none;\n  padding: 0.875rem 1.5rem;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n  white-space: nowrap;\n}\n\n.clients-btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);\n}\n\n.clients-btn-primary:active {\n  transform: translateY(0);\n}\n\n/* Tableau */\n.clients-table {\n  width: 100%;\n  background: white;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  border-collapse: collapse;\n}\n\n.clients-table thead {\n  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);\n}\n\n.clients-table thead th {\n  padding: 1.25rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  color: white;\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.clients-table tbody tr {\n  border-bottom: 1px solid #f1f5f9;\n  transition: all 0.2s ease;\n}\n\n.clients-table tbody tr:hover {\n  background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%);\n  transform: scale(1.005);\n}\n\n.clients-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.clients-table tbody td {\n  padding: 1rem;\n  color: #374151;\n  font-size: 0.875rem;\n  vertical-align: middle;\n}\n\n/* Badge de statut */\n.status-badge {\n  padding: 0.375rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  display: inline-block;\n  transition: all 0.2s ease;\n}\n\n.status-badge.active {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);\n}\n\n.status-badge.inactive {\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n  color: white;\n  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);\n}\n\n/* Boutons d'action */\n.clients-btn-edit,\n.clients-btn-delete {\n  background: none;\n  border: none;\n  padding: 0.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #6b7280;\n  margin: 0 0.25rem;\n}\n\n.clients-btn-edit:hover {\n  background: #dbeafe;\n  color: #3b82f6;\n  transform: scale(1.1);\n}\n\n.clients-btn-delete:hover {\n  background: #fee2e2;\n  color: #ef4444;\n  transform: scale(1.1);\n}\n\n/* Modal */\n.clients-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n  animation: clients-modal-fade-in 0.3s ease;\n}\n\n@keyframes clients-modal-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.clients-modal-box {\n  background: white;\n  border-radius: 20px;\n  padding: 2rem;\n  max-width: 500px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);\n  animation: clients-modal-slide-up 0.3s ease;\n}\n\n@keyframes clients-modal-slide-up {\n  from {\n    transform: translateY(50px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.clients-modal-title {\n  color: #1e293b;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 1.5rem;\n  text-align: center;\n  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Formulaire modal */\n.clients-modal-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.clients-modal-form input,\n.clients-modal-form select {\n  padding: 0.875rem;\n  border: 2px solid #e5e7eb;\n  border-radius: 10px;\n  font-size: 1rem;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.clients-modal-form input:focus,\n.clients-modal-form select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n  transform: translateY(-1px);\n}\n\n.clients-modal-form input::placeholder {\n  color: #9ca3af;\n}\n\n/* Actions de modal */\n.modal-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.clients-btn-save {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  border: none;\n  padding: 0.875rem 1.5rem;\n  border-radius: 10px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n  flex: 1;\n}\n\n.clients-btn-save:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);\n}\n\n.clients-btn-cancel {\n  background: #f3f4f6;\n  color: #374151;\n  border: none;\n  padding: 0.875rem 1.5rem;\n  border-radius: 10px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex: 1;\n}\n\n.clients-btn-cancel:hover {\n  background: #e5e7eb;\n  transform: translateY(-1px);\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .clients-container {\n    margin-left: 0;\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .clients-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .clients-filters {\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n\n  .clients-filters select,\n  .clients-filters input {\n    min-width: auto;\n    flex: 1;\n  }\n\n  .clients-table {\n    font-size: 0.75rem;\n  }\n\n  .clients-table thead th,\n  .clients-table tbody td {\n    padding: 0.75rem 0.5rem;\n  }\n\n  .clients-modal-box {\n    padding: 1.5rem;\n    margin: 1rem;\n  }\n\n  .modal-actions {\n    flex-direction: column;\n  }\n\n  .clients-btn-save,\n  .clients-btn-cancel {\n    flex: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .clients-title {\n    font-size: 2rem;\n  }\n\n  .clients-table thead th {\n    font-size: 0.75rem;\n    padding: 1rem 0.5rem;\n  }\n\n  .clients-table tbody td {\n    font-size: 0.75rem;\n    padding: 0.75rem 0.5rem;\n  }\n\n  .status-badge {\n    font-size: 0.625rem;\n    padding: 0.25rem 0.5rem;\n  }\n}\n\n/* Animations pour les interactions */\n.clients-table tbody tr,\n.clients-btn-primary,\n.clients-btn-save,\n.clients-btn-cancel,\n.clients-filters input,\n.clients-filters select {\n  will-change: transform;\n}\n\n/* Scrollbar personnalisée pour la modal */\n.clients-modal-box::-webkit-scrollbar {\n  width: 6px;\n}\n\n.clients-modal-box::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 3px;\n}\n\n.clients-modal-box::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n.clients-modal-box::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* États de chargement */\n.clients-table tbody tr.loading {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n/* Focus visible pour l'accessibilité */\n.clients-btn-primary:focus-visible,\n.clients-btn-save:focus-visible,\n.clients-btn-cancel:focus-visible,\n.clients-filters input:focus-visible,\n.clients-filters select:focus-visible {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}\n\n/* Effet de survol sur les lignes du tableau */\n.clients-table tbody tr:hover .status-badge.active {\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);\n}\n\n.clients-table tbody tr:hover .status-badge.inactive {\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);\n}\n\n/* Animation des boutons d'action */\n.clients-btn-edit,\n.clients-btn-delete {\n  position: relative;\n  overflow: hidden;\n}\n\n.clients-btn-edit::before,\n.clients-btn-delete::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  background: currentColor;\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n  transition: width 0.3s ease, height 0.3s ease;\n  opacity: 0.1;\n  z-index: -1;\n}\n\n.clients-btn-edit:hover::before,\n.clients-btn-delete:hover::before {\n  width: 100%;\n  height: 100%;\n}\n\n/* Amélioration de l'accessibilité */\n.clients-btn-edit:focus,\n.clients-btn-delete:focus {\n  outline: 2px solid currentColor;\n  outline-offset: 2px;\n}\n\n/* Style pour les messages d'erreur (prêt à utiliser) */\n.clients-error-message {\n  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n  color: #dc2626;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  border-left: 4px solid #ef4444;\n  margin-bottom: 1rem;\n  font-size: 0.875rem;\n}\n\n/* Style pour les messages de succès (prêt à utiliser) */\n.clients-success-message {\n  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\n  color: #059669;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  border-left: 4px solid #10b981;\n  margin-bottom: 1rem;\n  font-size: 0.875rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
